import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
// @mui
import { LoadingButton } from '@mui/lab';
import { Grid, Card, Stack, Button, Typography, Box, IconButton, Autocomplete, TextField, Select, MenuItem, FormControl, InputLabel, Divider, Checkbox, Tooltip } from '@mui/material';
// routes
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PATH_Admin, PATH_AllPages, PATH_MasterUser } from '../../../routes/paths';
// components
import { useSnackbar } from '../../../components/snackbar';
import FormProvider, { RHFSwitch, RHFUpload, RHFTextField, RHFAutocomplete, RHFRadioGroup, RHFEditor, RHFSelect, RHFSentenceCaseTextField, RHFPascalCaseTextField } from '../../../components/hook-form';
import { sentenceCase } from '../../../utils/SentenceCase';
//
import { RHFUploadImage, RHFUploadVideo, RHFUploadDocument } from '../../../components/hook-form/RHFUpload';
import UploadVideos from '../../../components/Upload/UploadVideo';
import UploadDocument from '../../../components/Upload/uploadpdfdocument';
import ContentEditor from '../../../components/editor/muieditortoolbar';
import BlogNewPostPreview from './BlogNewPostPreview';
import HelpServices from '../../../services/helpandcommunication.service';
import { fONDate, fDateforyyyyMMMdd, fDateForSNS, fDateStrIntoDate } from '../../../utils/formatTime';
import VideoPlayer from '../../admin/preview/videoplayer';
import ErrorMsgPopup from '../../../components/modal-popup/errorbmsgpopup';
import LoadingProgressBar from '../../../components/Loading-ProgressBar';
import Iconify from '../../../components/iconify';
import { handleError, ACCESSABLE_VALUE } from '../../../auth/utils';
// --------------------------------------------------------------------------------------------------------------

const Type_OPTION = [
    { label: 'Document', value: "2" },
    { label: 'Video', value: "3" },
    { label: 'Article', value: "1" },
];

// --------------------------------------------------------------------------------------------------------------

BlogNewPostForm.propTypes = {
    handleCategorychange: PropTypes.func,
    category: PropTypes.string,
    CategoryData: PropTypes.array,
    handleMenuchange: PropTypes.func,
    menuname: PropTypes.string,
    MenuData: PropTypes.array,
    rowData: PropTypes.object,
    isEdit: PropTypes.bool,
};
// --------------------------------------------------------------------------------------------------------------

export default function BlogNewPostForm({ category, CategoryData, MenuData, handleMenuchange, menuname, rowData,
    isEdit }) {

    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname.split('/')[1];
    const { enqueueSnackbar } = useSnackbar();
    const [openPreview, setOpenPreview] = useState(false);
    const [files, setFiles] = useState([]);
    const [documentfiles, setdocumentFiles] = useState([]);
    const [topictype, setTopictype] = useState('Article');
    const [hideVideoControl, setHideVideoControl] = useState(false);

    const [categoryData, setCategoryData] = useState([]);
    const [subcategoryData, setSubCategoryData] = useState([]);
    const [helpmenuData, setHelpMenuData] = useState([]);
    const [helpTags, setHelpTags] = useState([]);
    const [helpFranchise, setHelpFranchise] = useState([]);
    const [isUploaded, setIsUploaded] = useState(false);
    const [isVideochanged, setIsVideoChanged] = useState(false);
    const [isDocumentChanged, setIsDocumentChanged] = useState(false);
    const [iserror, setIsError] = useState(false);
    const [errormsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [attributeNameData, setAttributeNameData] = useState([]);
    const [attributeValueData, setAttributeValueData] = useState({});
    const [attributeData, setAttributeData] = useState([]);
    // const [attributeName, setAttributeName] = useState('');
    // const [attributeValue, setAttributeValue] = useState([]);

    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const addEditHelpTopicsPageAccess = loggedInUserDetails?.AddEditHelpTopicsPageAccess?.[0];
    const hasAddEditHelpTopicsPage = addEditHelpTopicsPageAccess?.HasAddEditHelpTopicsPage ?? '1';

    const SUPPORTED_FORMATS = ['application/pdf'];
    // const SUPPORTED_FORMATSVideo = ['video/mp4','audio/mp4'];
    const SUPPORTED_FORMATSVideo = ['video/mp4'];

    const NewBlogSchema = Yup.object().shape({
        types: Yup.number().required('Type is required'),

        // title: Yup.string()
        //    .min(10, 'Topic Title must be at least 10 characters.')
        //    .max(255, 'Topic Title has a maximum limit of 255 characters.')
        //    .required('Topic Title is required'),
        // description: Yup.string()
        //    .min(20, 'Description must be at least 20 characters.')
        //    .max(1024, 'Description has a maximum limit of 1024 characters.')
        //    .required('Description is required'),

        title: Yup.string()
            .min(1, 'Topic Title must be at least 1 characters.')
            .max(255, 'Topic Title has a maximum limit of 255 characters.')
            .required('Topic Title is required'),
        description: Yup.string()
            .min(10, 'Description must be at least 10 characters.')
            .max(1024, 'Description has a maximum limit of 1024 characters.')
            .required('Description is required'),
        franchise: Yup.string().required('Franchise is required'),

        //  menus: Yup.string().required('Menu is required'),
        //  owner: Yup.string()
        //    .min(1, 'Owner Name must be at least 1 character.')
        //    .max(255, 'Owner Name has a maximum limit of 255 characters.')
        //    .required('Owner Name is required'),
        //   tags: Yup.array().min(1, 'Tags has a maximum limit of 255 characters.'),

        cover: Yup.mixed().required('Cover is required').nullable(true),
        selectedFromDate: Yup.date().required('Published date is required'),
        selectedToDate: Yup.date()
            .required('Expiry date is required')
            .when('selectedFromDate', (selectedFromDate, schema) =>
                schema.test({
                    test: (selectedToDate) => !selectedFromDate || !selectedToDate || new Date(selectedToDate) >= new Date(selectedFromDate),
                    message: 'Expiry date must be greater than or equal to the Published date',
                })
            ),

        video: Yup.mixed().when('types', {
            is: 3,
            then: Yup.array().min(1, 'Please select as specified  file for upload .').test('fileType', "Unsupported File Format.Please upload video in video/mp4 format", value => {

                if (value.length > 0) {
                    if (value.every(item => typeof item === 'object' && item instanceof File)) {
                        const isSupported = SUPPORTED_FORMATSVideo.includes(value[0].type);
                        return isSupported;
                    }
                    // else
                    // {
                    //    const isSupported = value[0].endsWith('.mp4');

                    //    return isSupported;
                    // }
                    const isSupported = value[0].endsWith('.mp4');
                    return isSupported;
                }
                return false;
            }),
        }),

        document: Yup.mixed().when('types', {
            is: 2,
            then: Yup.array().min(1, 'Please select as specified  file for upload .').test('fileType', "Unsupported File Format.Please upload document in .pdf format", value => {

                if (value.length > 0) {
                    if (value.every(item => typeof item === 'object' && item instanceof File)) {
                        const isSupported = SUPPORTED_FORMATS.includes(value[0].type);
                        return isSupported;
                    }
                    /* else {
                        const isSupported = value[0].endsWith('.pdf');
                        return isSupported;
                    }
                    */
                    const isSupported = value[0].endsWith('.pdf');
                    return isSupported;
                }

                return false;
            }),
        }),

        article: Yup.string().when('types', {
            is: 1,
            then: Yup.string().required('Article is required'),
        }),
    });

    const defaultValues = {
        title: rowData?.topicName || '',
        description: rowData?.description || '',
        cover: rowData?.serverCoverImage ? `/UploadFiles/HelpTopic/CoverImages/${rowData?.serverCoverImage}` : null,
        types: rowData?.topicType.toString() || "2",
        tags: rowData?.tags?.split(',') || [],
        video: rowData?.topicType === 3 ? [`${rowData?.video}`] : [],
        document: rowData?.topicType === 2 ? [`${rowData?.document}`] : [],
        category: rowData?.categoryId || 1,
        subcategory: rowData?.subCategoryId || 0,
        owner: rowData?.ownerName || '',
        active: rowData?.status === 1 || !rowData?.status,
        download: rowData?.allowDownload === true || false,
        menus: rowData?.menuId || 0,
        franchise: rowData?.ownerFranchise || 'Null',
        article: rowData?.article || '',
        selectedFromDate: rowData?.publishedDate || new Date(),
        selectedToDate: rowData?.expiryDate || new Date(new Date().setFullYear(new Date().getFullYear() + 2)),
        attributes: rowData?.attributeName && rowData?.attributeValue
            ? rowData.attributeName.split(';').map((name, index) => ({
                attributeName: name || '',
                attributeValue: rowData.attributeValue.split(';')[index]?.split(',') || [],
            }))
            : [{ attributeName: '', attributeValue: [] }],
    };

    const methods = useForm({
        resolver: yupResolver(NewBlogSchema),
        defaultValues,
    });

    const {
        reset,
        watch,
        setValue,
        control,
        handleSubmit,
        formState: { isSubmitting, isValid, errors },
    } = methods;

    const values = watch();

    const handleAttributeChange = (index, attributeName, selectedValues) => {
        if (isEdit || selectedValues.length > 0) {
            setValue(`attributes[${index}].attributeName`, attributeName);
            setValue(`attributes[${index}].attributeValue`, selectedValues.length === 0 ? [""] : selectedValues);
        } else {
            setValue(`attributes[${index}].attributeName`, '');
            setValue(`attributes[${index}].attributeValue`, [""]);
        }
    };

    const handleOpenPreview = () => {
        setOpenPreview(true);
    };

    const handleClosePreview = () => {
        setOpenPreview(false);
    };

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            await new Promise((resolve) => setTimeout(resolve, 500));
            // reset();

            const formData = new FormData();
            formData.append("TopicName", sentenceCase(data.title));
            formData.append("Description", sentenceCase(data.description));
            formData.append("Status", data.active ? 1 : 2);
            formData.append("CategoryId", data.category);
            formData.append("SubCategoryId", data.subcategory);
            formData.append("MenuId", data.menus);
            formData.append("Tags", data.tags.join(','));
            formData.append("PublishedDate", fDateForSNS(data.selectedFromDate));
            formData.append("ExpiryDate", fDateForSNS(data.selectedToDate));
            formData.append("TopicType", data.types);
            formData.append("Article", data?.article);
            formData.append("OwnerName", data?.owner);
            formData.append("OwnerFranchise", data?.franchise);
            formData.append("AllowDownload", data?.download);

            // Format dynamic AttributeName and AttributeValue based on `attributes`
            const attributeNames = data.attributes
                .filter(attr => attr.attributeName)
                .map(attr => attr.attributeName)
                .join(';');
            const attributeValues = data.attributes
                .filter(attr => Array.isArray(attr.attributeValue) && attr.attributeValue.length > 0)
                .map(attr => attr.attributeValue.join(','))
                .join(';');

            formData.append("AttributeName", attributeNames);
            formData.append("AttributeValue", attributeValues);

            if (isEdit) {
                formData.append("Id", rowData.id);

                if (typeof data.cover === 'string') {
                    formData.append("CoverImageFile", null);
                    formData.append("CoverImage", rowData.coverImage);
                    formData.append("ServerCoverImage", rowData.serverCoverImage);
                }
                else if (typeof data.cover === 'object' && data.cover instanceof File) {
                    formData.append("CoverImageFile", data.cover);
                    formData.append("CoverImage", "");
                    formData.append("ServerCoverImage", "");
                }

                if (data.video && data.video.every(item => typeof item === 'string')) {
                    formData.append("VideoFile", null);
                    formData.append("Video", rowData.video);
                    formData.append("ServerVideo", rowData.serverVideo);
                }
                else if (data.video && data.video.every(item => typeof item === 'object' && item instanceof File)) {
                    formData.append("VideoFile", data.video[0]);
                    formData.append("Video", "");
                    formData.append("ServerVideo", "");
                }

                if (data.document && data.document.every(item => typeof item === 'object' && item instanceof File)) {
                    formData.append("DocumentFile", data.document[0]);
                    formData.append("Document", "");
                    formData.append("ServerDocument", "");
                }
                else if (data.document && data.document.every(item => typeof item === 'string')) {
                    formData.append("DocumentFile", null);
                    formData.append("Document", rowData.document);
                    formData.append("ServerDocument", rowData.serverDocument);
                }

                HelpServices.UpdateHelpTopic(formData)
                    .then((response) => {
                        if (response.status === 200) {
                            // enqueueSnackbar('Update success!');
                            if (path === 'helpadmin') {
                                navigate(PATH_Admin.root);
                            }
                            else if (path === 'masteruser') {
                                navigate(PATH_MasterUser.helptopics);
                            }
                            else {
                                navigate(PATH_AllPages.helptopics);
                            }
                            setLoading(false);
                        }
                        else {
                            // TODO: Handle error and show it to user
                            console.log("error");
                            setErrorMsg(response.data);
                            setIsError(true);
                            setLoading(false);
                        }
                    })
                    .catch(_error => {
                        // TODO: Handle error and show it to user
                        setIsError(true);
                        setErrorMsg("Failed to update help topic");
                        // setOpenModalForError(true);
                        // handleError(_error, navigate, "", "");
                    });
            }
            else {
                formData.append("CoverImage", data.cover);
                formData.append("Video", data.video[0]);
                formData.append("Document", data.document[0]);

                console.log("formData", formData);

                HelpServices.CreateHelpTopics(formData)
                    .then((response) => {
                        if (response.status === 200) {
                            //  enqueueSnackbar('Create success!');
                            setLoading(false);
                            if (path === 'helpadmin') {
                                navigate(PATH_Admin.root);
                            }
                            else if (path === 'masteruser') {
                                navigate(PATH_MasterUser.helptopics);
                            }
                            else {
                                navigate(PATH_AllPages.helptopics);
                            }
                        }
                        else {
                            // TODO: Handle error and show it to user
                            console.log("error")
                            setLoading(false);
                            setErrorMsg(response.data);
                            setIsError(true);
                        }
                    })
                    .catch(_error => {
                        setLoading(false);
                        setIsError(true);
                        setErrorMsg("Failed to  create help topic.");
                        // TODO: Handle error and show it to user
                        // setErrorMsg("Unable to get cut off day.");
                        // setOpenModalForError(true);
                        // handleError(_error, navigate, "", "");
                    });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleDrop = useCallback(
        (acceptedFiles) => {
            const file = acceptedFiles[0];
            const newFile = Object.assign(file, {
                preview: URL.createObjectURL(file),
            });

            if (file) {
                setValue('cover', newFile, { shouldValidate: true });
            }
        },
        [setValue]
    );

    const handleVideoDrop = useCallback(
        (acceptedFiles) => {
            const filevideo = acceptedFiles[0];

            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            );

            if (isEdit && rowData?.topicType === 3)
                setIsVideoChanged(true);

            setFiles(newFiles);
            setdocumentFiles([]);

            if (filevideo) {
                setValue('video', newFiles, { shouldValidate: true });
            }
        },
        [isEdit, rowData, setValue]
    );

    const handleDocumentDrop = useCallback(

        (acceptedFiles) => {
            const filedoc = acceptedFiles[0];

            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            );

            if (isEdit && rowData?.topicType === 2)
                setIsDocumentChanged(true);

            setdocumentFiles(newFiles);
            setFiles([])
            if (filedoc) {
                setValue('document', newFiles, { shouldValidate: true });
            }
        }, [isEdit, rowData, setValue]
    );

    const handleRemoveFile = () => {
        setValue('cover', null);
    };

    const handleVideoRemoveFile = (inputFile) => {
        const filtered = files.filter((file) => file !== inputFile);
        setFiles(filtered);
        setHideVideoControl(false);
        setValue('video', null);
        // setIsUploaded(false);
    };

    const handleDocumentRemoveFile = (inputFile) => {
        const filtered = documentfiles.filter((file) => file !== inputFile);
        setdocumentFiles(filtered);
        setValue('document', null);
    };

    const handleErrorConfirm = () => {
        setIsError(false);
    }

    const handleradiochange = (event) => {
        setFiles([]);
        setdocumentFiles([]);
        setValue('article', "");
        setValue('types', event.target.value);
    }

    //  const handleFromDateChange = useCallback((newValue) => {
    //    // Your custom validation logic for from date
    //    const isValidFromDate = newValue > new Date(); // Add your own validation condition
    //    setFromDateError(isValidFromDate ? null : 'Publish date must be in the future');
    //  }, []);

    //  const handleToDateChange = useCallback((newValue) => {
    //    // Your custom validation logic for to date
    //    const isValidToDate = newValue > values.selectedFromDate; // Add your own validation condition
    //    setToDateError(isValidToDate ? null : 'Expiry date must be after publish date');
    //  }, [values.selectedFromDate]);

    useEffect(() => {
        if (rowData?.serverVideo) {
            fetch(`/UploadFiles/HelpTopic/Videos/${rowData?.serverVideo}`)
                .then(response => response.blob())
                .then(videoBlob => {
                    // Create a File object for the video
                    const videoFile = new File([videoBlob], rowData?.video, { type: 'video/mp4' });
                    // Set the File object in the state
                    setFiles([videoFile]);
                })
                .catch(error => {
                    console.error('Error fetching video:', error);
                });
        }

        if (rowData?.serverDocument) {
            fetch(`/UploadFiles/HelpTopic/Documents/${rowData?.serverDocument}`)
                .then(response => response.blob())
                .then(videoBlob => {
                    // Create a File object for the video
                    const videoFile = new File([videoBlob], rowData?.document, { type: 'application/pdf' });
                    // Set the File object in the state
                    setdocumentFiles([videoFile]);
                })
                .catch(error => {
                    console.error('Error fetching video:', error);
                });
        }

        HelpServices.GetHelpCategories()
            .then((response) => {
                if (response.status === 200) {
                    setCategoryData(response.data)
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                }
            })
            .catch(_error => {
                // TODO: Handle error and show it to user
                // setErrorMsg("Unable to get cut off day.");
                // setOpenModalForError(true);
                // handleError(_error, navigate, "", "");
            });

        HelpServices.GetHelpTags()
            .then((response) => {
                if (response.status === 200) {
                    setHelpTags(response.data)
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                }
            })
            .catch(_error => {
                // TODO: Handle error and show it to user
                // setErrorMsg("Unable to get cut off day.");
                // setOpenModalForError(true);
                // handleError(_error, navigate, "", "");
            });

        HelpServices.GetHelpFranchise()
            .then((response) => {
                if (response.status === 200) {
                    setHelpFranchise(response.data)
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                }
            })
            .catch(_error => {
                // TODO: Handle error and show it to user
                // setErrorMsg("Unable to get cut off day.");
                // setOpenModalForError(true);
                // handleError(_error, navigate, "", "");
            });

    }, [rowData, navigate]);

    useEffect(() => {
        const categoryName = categoryData ? categoryData.find((item) => item.id === values.category)?.categoryName : 'JJ Core'

        const payload = { CategoryName: isEdit ? rowData.categoryName : categoryName }

        /*   HelpServices.GetHelpMenus(payload)
               .then((response) => {
                   if (response.status === 200) {
                       setHelpMenuData(response.data)
                       //    setValue('menus',isEdit ? rowData.menuId : "None")
                       //   setValue('menus',"1")
                   }
                   else {
                       // TODO: Handle error and show it to user
                       console.log("error")
                   }
               })
               .catch(_error => {
                   // TODO: Handle error and show it to user
                   // setErrorMsg("Unable to get cut off day.");
                   // setOpenModalForError(true);
                   // handleError(_error, navigate, "", "");
               });     */

        const categoryId = categoryData ? values.category : 1

        const subpayload = { CategoryId: isEdit ? rowData.categoryId : categoryId }

        HelpServices.GetSubCategoriesbyCategoryId(subpayload)
            .then((response) => {
                if (response.status === 200) {
                    setSubCategoryData(response.data)
                    //    setValue('menus',isEdit ? rowData.menuId : "None")
                    //   setValue('menus',"1")
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                }
            })
            .catch(_error => {
                // TODO: Handle error and show it to user
                // setErrorMsg("Unable to get cut off day.");
                // setOpenModalForError(true);
                // handleError(_error, navigate, "", "");
            });
    }, [values.category, categoryData, isEdit, rowData]);

    useEffect(() => {
        HelpServices.GetHelpTopicAttributeName()
            .then((response) => {
                if (response.status === 200) {
                    setAttributeNameData(response.data)
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error")
                }
            })
            .catch(_error => {
                handleError(_error, navigate, "", "");
            });
    }, [navigate]);

    useEffect(() => {
        if (values.attributes && values.attributes[0]?.attributeName) {
            const existingAttributeNames = values.attributes.map(attr => attr.attributeName);

            const missingAttributes = attributeNameData
                .filter(attrData => !existingAttributeNames.includes(attrData.attributeName))
                .map(attrData => ({
                    attributeName: attrData.attributeName,
                    attributeValue: []
                }));

            const updatedAttributeData = [...values.attributes, ...missingAttributes];

            setAttributeData(updatedAttributeData);
        } else {
            setAttributeData(attributeNameData);
        }
    }, [attributeNameData, values.attributes]);

    useEffect(() => {
        if (attributeNameData.length > 0) {
            setLoading(true);
            // Loop through attributeNameData and execute the API call for each attributeName
            attributeNameData.forEach((item) => {
                const payload = { attributeName: item.attributeName };

                // Make the API call to fetch attribute values
                HelpServices.GetHelpTopicAttributeValues(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            setLoading(false);
                            // Store the results in the state object, keyed by attributeName
                            setAttributeValueData((prevData) => ({
                                ...prevData,
                                [item.attributeName]: response.data, // Save the result for each attributeName
                            }));
                        } else {
                            setLoading(false);
                            // TODO: Handle error and show it to the user
                            console.log("Error fetching data for", item.attributeName);
                        }
                    })
                    .catch((error) => {
                        handleError(error, navigate, "", setLoading);
                    });
            });
        }
    }, [navigate, attributeNameData]);

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12} md={12}>
                <Card sx={{ p: 3, height: 'auto', mb: 2 }} >
                    <Grid item xs={12} md={8}>
                        <Stack spacing={3}>
                            <RHFSentenceCaseTextField name="title" label="Topic Title"
                                inputProps={{ autoComplete: 'off' }}
                                disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                            />

                            <RHFSentenceCaseTextField name="description" label="Short Description"
                                multiline rows={3} inputProps={{ autoComplete: 'off' }}
                                disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                            />

                            <Stack spacing={1}>
                                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                    Topic Type :
                                </Typography>

                                <RHFRadioGroup row spacing={10} name="types"
                                    disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                    options={Type_OPTION}
                                    onChange={handleradiochange}
                                />
                            </Stack>

                            <Stack spacing={1}>
                                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                    Cover Image
                                </Typography>
                                <RHFUploadImage
                                    name="cover"
                                    maxSize={3145728}
                                    disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                    onDrop={handleDrop}
                                    onDelete={handleRemoveFile}
                                />
                            </Stack>

                            {values.types === "1" &&
                                <>
                                    <Divider textAlign="center" variant="h6" >Attachments</Divider>  <Stack spacing={1}>
                                        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                            Article
                                        </Typography>

                                        <RHFEditor simple name="article"
                                            disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                        />
                                    </Stack>
                                </>
                            }

                            {values.types === "3" &&
                                <>
                                    <Divider textAlign="center" variant="h6" >Attachments</Divider>
                                    <Stack spacing={1}>
                                        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                            Video
                                        </Typography>

                                        {!isUploaded ? (
                                            <RHFUploadVideo
                                                name="video"
                                                accept={{ '*': [] }}
                                                maxSize={31457283435436}
                                                multiple
                                                disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                                onDrop={handleVideoDrop}
                                                onRemove={handleVideoRemoveFile}
                                                note="Please Upload Videos of size less than 300Mb in .Mp4 format."
                                            />
                                        ) : (
                                            <VideoPlayer sourceURL={files} />
                                        )}
                                    </Stack>
                                </>
                            }

                            {values.types === "2" &&
                                <>
                                    <Divider textAlign="center" variant="h6" >Attachments</Divider>
                                    <Stack spacing={1}>
                                        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                            Documents
                                        </Typography>
                                        <RHFSwitch
                                            name="download"
                                            label="Allow download"
                                            labelPlacement="start"
                                            disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                            sx={{ mb: 2, mx: 0, width: { xs: 300, md: 410 }, justifyContent: 'space-between' }}
                                        />
                                        <RHFUploadDocument
                                            name="document"
                                            multiple
                                            disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                            onDrop={handleDocumentDrop}
                                            onRemove={handleDocumentRemoveFile}
                                            note="Please Upload Documents of size between 60kb to 70kb in .pdf format."
                                        />
                                    </Stack>
                                </>
                            }

                            <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                                <RHFSelect
                                    fullWidth
                                    name="category"
                                    label="Category"
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                >
                                    {categoryData?.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.categoryName}
                                        </MenuItem>
                                    ))}
                                </RHFSelect>

                                <RHFSelect
                                    fullWidth
                                    name="subcategory"
                                    label="Sub-Category"
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                >
                                    <MenuItem key="None" value={0} >
                                        None
                                    </MenuItem>
                                    {subcategoryData?.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.subCategoryName}
                                        </MenuItem>
                                    ))}
                                </RHFSelect>
                            </Stack>

                            <Box sx={{ alignItems: 'center', pt: 1 }}
                                rowGap={3}
                                columnGap={3}
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(1, 1fr)',
                                    md: 'repeat(2, 1fr)',
                                }}
                            >
                                <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                                    {/*    <RHFSelect fullWidth name="menus" label="Menu" InputLabelProps={{ shrink: true }} size="small">
                                    <MenuItem key="None" value={0} >
                                        None
                                    </MenuItem>
                                    {helpmenuData?.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.menuName}
                                        </MenuItem>
                                    ))}
                                </RHFSelect>    */}

                                    <RHFAutocomplete
                                        fullWidth
                                        name="tags"
                                        label="Tags"
                                        multiple
                                        disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                        options={helpTags?.map((option) => option.code)}
                                        ChipProps={{ size: 'small' }}
                                        size="small"
                                    />
                                </Stack>

                                {attributeData.length > 0 && attributeData.map((field, index) => (
                                    <Stack key={index} spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                                        {/*  <Typography variant="body1" sx={{ my: 1, width: 100 }}>
                                        {field.attributeName}
                                    </Typography>   */}

                                        <RHFAutocomplete
                                            name={`attributes[${index}].attributeValue`}
                                            fullWidth
                                            multiple
                                            disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                            options={attributeValueData[field.attributeName]?.map((option) => option.code) || []}
                                            size="small"
                                            disableCloseOnSelect
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox checked={selected} style={{ marginRight: 8 }} />
                                                    {option}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField {...params} label={field.attributeName} variant="outlined" />
                                            )}
                                            renderTags={(value) => value.join(', ')}
                                            defaultValue={isEdit ? field.attributeValue || [] : []}
                                            // value={field.value || []}
                                            onChange={(e, newValue) => {
                                                const cleanedValues = newValue.filter((value) => value.trim() !== '');
                                                handleAttributeChange(index, field.attributeName, cleanedValues);
                                            }}
                                        />
                                    </Stack>
                                ))}
                            </Box>

                            <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                                <Controller
                                    name="selectedFromDate"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="Publish Date"
                                                inputFormat="dd-MMM-yyyy"
                                                disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                                value={field.value}
                                                onChange={(newValue) => field.onChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        size="small"
                                                        {...params}
                                                        sx={{
                                                            width: "100%",
                                                            '& .MuiInputBase-root': {
                                                                fontSize: '0.8rem',
                                                                height: '32px'
                                                            },
                                                        }}
                                                        error={!!fieldState.error}
                                                        helperText={fieldState.error?.message}
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />

                                <Controller
                                    name="selectedToDate"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="Expiry Date"
                                                inputFormat="dd-MMM-yyyy"
                                                value={field.value}
                                                disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                                onChange={(newValue) => field.onChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        size="small"
                                                        {...params}
                                                        sx={{
                                                            width: "100%",
                                                            '& .MuiInputBase-root': {
                                                                fontSize: '0.8rem',
                                                                height: '32px'
                                                            },
                                                        }}
                                                        error={!!fieldState.error}
                                                        helperText={fieldState.error?.message}
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </Stack>

                            <Divider textAlign="center" variant="h6" >Other Details</Divider>

                            <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                                <RHFPascalCaseTextField name="owner" label="Owner Name" size="small"
                                    disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                />

                                <RHFSelect fullWidth name="franchise" label="Franchise"
                                    InputLabelProps={{ shrink: true }} size="small"
                                    disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                >
                                    <MenuItem key="None" value="Null" >
                                        None
                                    </MenuItem>
                                    {helpFranchise?.map((option) => (
                                        <MenuItem key={option.franchise} value={option.franchise}>
                                            {option.franchise}
                                        </MenuItem>
                                    ))}
                                </RHFSelect>
                            </Stack>

                            <RHFSwitch
                                name="active"
                                label="Active"
                                disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                                checked
                                labelPlacement="start"
                                sx={{ mb: 2, mx: 0, width: { xs: 300, md: 410 }, justifyContent: 'space-between' }}
                            />
                        </Stack>
                    </Grid>
                </Card>
            </Grid>

            <Box sx={{ my: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button
                        fullWidth
                        color="inherit"
                        variant="outlined"
                        size="medium"
                        disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                        onClick={handleOpenPreview}
                        sx={{ width: '15ch' }}
                    >
                        Preview
                    </Button>

                    <LoadingButton
                        fullWidth
                        type="submit"
                        variant="contained"
                        size="medium"
                        disabled={hasAddEditHelpTopicsPage !== ACCESSABLE_VALUE}
                        loading={isSubmitting}
                        sx={{ width: '15ch' }}
                    >
                        {isEdit ? 'Save Changes' : 'Save'}
                    </LoadingButton>
                </Stack>

                {iserror && <ErrorMsgPopup confirm={handleErrorConfirm} msg={errormsg} header="Error" />}
            </Box>

            <BlogNewPostPreview
                values={values}
                open={openPreview}
                isValid={isValid}
                isSubmitting={isSubmitting}
                onClose={handleClosePreview}
                onSubmit={handleSubmit(onSubmit)}
                editorContent={values.article}
                topicType={topictype}
                videoFiles={files}
                documentFiles={documentfiles}
            />

            {loading && <LoadingProgressBar />}
        </FormProvider >
    );
}
